import { actionTypes } from '../actions/params';

// DEFAULT STATE
export const initParams = {
  wtRegion : 'US',
  clientEmail : 'unknown@unknown.com',
  dataspanApiUrl : 'https://dataspanapidev.wisdomtree.com/',
  token : '',
  version : 'VDEV',
  pdfReportConfigId: '',
};

// WRITES
const params = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_SAMPLE_PARAM:
      return Object.assign({}, state, {
        sampleParam: action.value,
      });
    default:
      return state;
  }
};

export default params;
